import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { ReflexDefinition } from "../../../services/admin/reflexes.service";

interface Props {
  reflex?: ReflexDefinition;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ReflexStatusConfirmModal({
  reflex,
  isSubmitting,
  onClose,
  onConfirm,
}: Props) {
  const activating = !reflex?.isActive;
  return (
    <Modal
      opened={Boolean(reflex)}
      onClose={onClose}
      closeOnClickOutside={false}
      centered
      title={`${activating ? "Activate" : "Deactivate"} reflex`}
    >
      <Stack>
        <Text>
          {activating ? "Make" : "Hide"} <strong>{reflex?.name}</strong>{" "}
          {activating
            ? "available for new accessioning orders?"
            : "from new accessioning orders?"}
        </Text>
        {!activating && (
          <Alert icon={<IconAlertTriangle size={18} />} color="orange">
            Existing enrollments and accepted panel orders are retained for
            history and processing.
          </Alert>
        )}
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            color={activating ? "blue" : "orange"}
            loading={isSubmitting}
            onClick={onConfirm}
          >
            {activating ? "Activate" : "Deactivate"}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
